'use client';

const QUESTIONS = [
  '裏地の付け方を教えて',
  'ファスナーの付け方のコツは？',
  '接着芯はどう使うの？',
  '型紙を写す方法を教えて',
  '初心者におすすめの道具は？',
  'minneで売れるハンドメイドの特徴は？',
];

interface Props {
  onSelect: (q: string) => void;
}

export default function SuggestedQuestions({ onSelect }: Props) {
  return (
    <div className="fade-in fade-in-delay-1">
      <p style={{ color: 'var(--color-muted)', letterSpacing: '0.15em' }} className="text-xs mb-3">
        よく聞かれる質問
      </p>
      <div className="flex flex-wrap gap-2">
        {QUESTIONS.map(q => (
          <button
            key={q}
            onClick={() => onSelect(q)}
            style={{
              border: '1px solid var(--color-border)',
              color: 'var(--color-body)',
              backgroundColor: 'transparent',
              letterSpacing: '0.05em',
            }}
            className="text-sm px-4 py-1.5 rounded-full transition-all duration-300 hover:border-[var(--color-accent)] hover:text-[var(--color-accent)]"
          >
            {q}
          </button>
        ))}
      </div>
    </div>
  );
}
